<div class="demo-page">
  <app-header></app-header>

  <div class="demo-content">
    <div class="demo-header">
      <a routerLink="/challenges" class="demo-back">← Back to Challenges</a>
      <h1>Challenge Card Design Options</h1>
      <p>Compare the five design variants below. Each uses the same sample data.</p>
    </div>

    <div class="demo-grid">
      <!-- Option A: Minimal Horizontal (Thumbnail Left) -->
      <section class="demo-section">
        <h2>Option A: Minimal Horizontal</h2>
        <p class="demo-desc">Compact thumbnail-left layout. Best for dense list views.</p>
        <div class="card-variant card-a">
          <div class="card-a--thumb">
            <img [src]="getImageUrl()" [alt]="sampleData.name" />
          </div>
          <div class="card-a--main">
            <h3>{{ sampleData.name }}</h3>
            <p class="provider">{{ sampleData.provider }}</p>
            <div class="card-a--stats">
              <span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>{{ sampleData.participants }}</span>
              <span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>{{ formatPrize(sampleData.prizeMoney) }}</span>
              <span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>{{ formatDays(sampleData.daysRemaining) }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Option B: Glassmorphism -->
      <section class="demo-section">
        <h2>Option B: Glassmorphism</h2>
        <p class="demo-desc">Soft elevated look with gradient accent bar.</p>
        <div class="card-variant card-b">
          <div class="card-b--accent"></div>
          <div class="card-b--thumb">
            <img [src]="getImageUrl()" [alt]="sampleData.name" />
          </div>
          <div class="card-b--body">
            <h3>{{ sampleData.name }}</h3>
            <p class="provider">{{ sampleData.provider }}</p>
            <div class="card-b--stats">
              <span>{{ sampleData.participants }}</span>
              <span>{{ formatPrize(sampleData.prizeMoney) }}</span>
              <span>{{ formatDays(sampleData.daysRemaining) }}</span>
            </div>
            <div class="card-b--action">View details →</div>
          </div>
        </div>
      </section>

      <!-- Option C: Full-Width Hero Image -->
      <section class="demo-section">
        <h2>Option C: Hero Image</h2>
        <p class="demo-desc">Image-first with overlay. Best for featured/marketing cards.</p>
        <div class="card-variant card-c">
          <div class="card-c--hero">
            <img [src]="getImageUrl()" [alt]="sampleData.name" />
            <div class="card-c--overlay">
              <h3>{{ sampleData.name }}</h3>
              <p>{{ sampleData.provider }}</p>
            </div>
          </div>
          <div class="card-c--strip">
            <span>{{ sampleData.participants }} participants</span>
            <span>{{ formatPrize(sampleData.prizeMoney) }}</span>
            <span>{{ formatDays(sampleData.daysRemaining) }}</span>
          </div>
        </div>
      </section>

      <!-- Option D: Wide Horizontal -->
      <section class="demo-section">
        <h2>Option D: Wide Horizontal</h2>
        <p class="demo-desc">Large image left, content right. Good for wider cards.</p>
        <div class="card-variant card-d">
          <div class="card-d--image">
            <img [src]="getImageUrl()" [alt]="sampleData.name" />
          </div>
          <div class="card-d--content">
            <h3>{{ sampleData.name }}</h3>
            <p class="provider">{{ sampleData.provider }}</p>
            <div class="card-d--stats">
              <div><strong>{{ sampleData.participants }}</strong> participants</div>
              <div><strong>{{ formatPrize(sampleData.prizeMoney) }}</strong> prize</div>
              <div><strong>{{ formatDays(sampleData.daysRemaining) }}</strong></div>
            </div>
            <button class="card-d--btn">View Challenge</button>
          </div>
        </div>
      </section>

      <!-- Option E: Bento / Asymmetric -->
      <section class="demo-section">
        <h2>Option E: Bento Grid</h2>
        <p class="demo-desc">Asymmetric layout for editorial feel.</p>
        <div class="card-variant card-e">
          <div class="card-e--image">
            <img [src]="getImageUrl()" [alt]="sampleData.name" />
          </div>
          <div class="card-e--stats">
            <div><span>{{ sampleData.participants }}</span>Participants</div>
            <div><span>{{ formatPrize(sampleData.prizeMoney) }}</span>Prize</div>
            <div><span>{{ formatDays(sampleData.daysRemaining) }}</span>Deadline</div>
          </div>
          <div class="card-e--main">
            <h3>{{ sampleData.name }}</h3>
            <p class="provider">{{ sampleData.provider }}</p>
            <a href="#" class="card-e--link">View details →</a>
          </div>
        </div>
      </section>

      <!-- Current Banner (for reference) -->
      <section class="demo-section">
        <h2>Current: Banner Style</h2>
        <p class="demo-desc">The design currently used on the challenges page.</p>
        <app-challenge-card [data]="sampleData" [showDescription]="false" [disableNavigation]="true"></app-challenge-card>
      </section>
    </div>
  </div>

  <app-footer></app-footer>
</div>
